import {Component, Input, OnInit} from '@angular/core';
import {BaseWidgetComponent} from '../base-widget.component';
import {TabReportResult} from '../../../_models/report/tab-report-result';
import {TabReportService} from '../../../_services/tab-report.service';
import {Column} from '../../../_models/report/column';
import {ColumnFormatterService} from '../../../_services/column-formatter.service';

@Component({
    selector: 'bb-list-widget',
    templateUrl: './list-widget.component.html',
    styleUrls: ['./list-widget.component.scss'],
})
export class ListWidgetComponent extends BaseWidgetComponent implements OnInit {
    @Input() pageSize = 5;
    tabReportResult: TabReportResult;
    detailColumns: Column[];
    labelColumn: Column;
    valueColumn: Column;

    constructor(
        private tabReportService: TabReportService,
        columnFormatterService: ColumnFormatterService
    ) {
        super(columnFormatterService);
    }

    ngOnInit(): void {
    }

    refresh() {
        this.loading = true;
        this.dataLoading.emit();
        this.tabReportService.runShell(this.getFilteredReport(), 0, this.pageSize, this.startDate, this.endDate, null, true)
            .subscribe((trr: TabReportResult) => {
                this.tabReportResult = trr;
                this.detailColumns = trr.columns.slice(1, trr.columns.length - 1);
                this.labelColumn = trr.columns[0];
                this.valueColumn = trr.columns[trr.columns.length - 1];

                this.loading = false;
                this.error = false;
                this.dataReady.emit();
            }, () => {
                this.error = true;
                this.loading = false;
            });
    }
}
